import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Divider, Heading } from '@chakra-ui/react';
export default function TitleField({ id, title, }) {
    return (_jsxs(Box, { id: id, mt: 1, mb: 4, children: [_jsx(Heading, { as: 'h5', children: title }), _jsx(Divider, {})] }));
}
//# sourceMappingURL=TitleField.js.map